<script>
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';

export default {
  components: {},
  props: {
    content: {
      type: [String, Number],
      required: true,
    },
    // Current cell size
    sizeX: {
      type: Number,
      required: true,
    },
    sizeY: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const { formatMessage } = useMessageFormatter();
    return { formatMessage };
  },
  validations: {},
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    fontSize() {
      const smallCellX = this.sizeX === 1;
      const smallCellY = this.sizeY === 1;

      const smallScreen = this.windowWidth < 1400;
      const mediumScreen = this.windowWidth >= 1400 && this.windowWidth < 1900;
      const largeScreen = !smallScreen && !mediumScreen;

      const stringBiggerThanFiveCharacters = this.content.toString().length > 5;
      const stringBiggerThanTenCharacters = this.content.toString().length > 10;
      const stringBiggerThanTwentyCharacters =
        this.content.toString().length > 20;

      const stringContainsMoreThanTwoLines =
        this.content.split(/\r\n|\r|\n/).length / 2 > 2; // Divide por 2 pois está duplicando os '\n'

      if (largeScreen) {
        if (
          stringBiggerThanTwentyCharacters ||
          stringContainsMoreThanTwoLines
        ) {
          return 'text-2xl';
        }
        if (stringBiggerThanTenCharacters && (smallCellX || smallCellY)) {
          return 'text-3xl';
        }
        if (stringBiggerThanTenCharacters || smallCellX || smallCellY) {
          return 'text-5xl';
        }
        if (stringBiggerThanFiveCharacters && (smallCellX || smallCellY)) {
          return 'text-6xl';
        }
        return 'text-7xl';
      }

      if (mediumScreen) {
        if (
          stringBiggerThanTwentyCharacters ||
          stringContainsMoreThanTwoLines
        ) {
          return 'text-1xl';
        }
        if (stringBiggerThanTenCharacters && (smallCellX || smallCellY)) {
          return 'text-2xl';
        }
        if (stringBiggerThanTenCharacters || smallCellX || smallCellY) {
          return 'text-4xl';
        }
        if (stringBiggerThanFiveCharacters || (smallCellX && smallCellY)) {
          return 'text-6xl';
        }
        return 'text-6xl';
      }

      if (smallScreen) {
        if (stringContainsMoreThanTwoLines || stringBiggerThanTenCharacters) {
          return 'text-base';
        }
        if (stringBiggerThanTenCharacters && (smallCellX || smallCellY)) {
          return 'text-2xl';
        }
        if (stringBiggerThanTenCharacters || smallCellX || smallCellY) {
          return 'text-4xl';
        }
        return 'text-5xl';
      }

      return 'text-8xl'; // Default size for very large screens or short content
    },
    paddingClass() {
      if (this.windowWidth >= 1900) return 'padding-lg';
      if (this.windowWidth >= 1600) return 'padding-md';
      return 'padding-sm';
    },
    messageForStaticText() {
      return this.formatMessage(this.content);
    },
  },
  mounted() {
    // Adiciona o listener para o evento de redimensionamento da tela
    window.addEventListener('resize', this.updateWindowDimensions);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  },
  methods: {
    updateWindowDimensions() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<template>
  <div
    class="w-full h-full px-6 leading-none text-center flex justify-center items-center"
  >
    <div
      id="staticTextContent"
      v-dompurify-html="messageForStaticText"
      class="max-h-full max-w-full leading-none"
      :class="[fontSize, paddingClass]"
    />
  </div>
</template>

<style>
.padding-lg ul,
.padding-lg ol {
  padding-left: 30px;
}

.padding-md ul,
.padding-md ol {
  padding-left: 25px;
}

.padding-sm ul,
.padding-sm ol {
  padding-left: 20px;
}

#staticTextContent p,
#staticTextContent a {
  font-size: inherit;
}

#staticTextContent li {
  text-align: left;
}

#staticTextContent ol {
  list-style-type: decimal;
}

/* Estilo para negrito */
#staticTextContent {
  font-weight: 450;
  color: #222222;
}

#staticTextContent strong,
#staticTextContent b {
  font-weight: 1000;
  font-size: 1.1em;
  color: #070707;
}
</style>
